import { useEffect, useRef, useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Tooltip,
  Divider,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import Radio from "@mui/material/Radio";
import InsertDriveFileTwoToneIcon from "@mui/icons-material/InsertDriveFileTwoTone";
import CloseIcon from "@mui/icons-material/Close";

import { SampleJsonData, histroricalDummyData } from "./dummyjson";
import ChooseFile from "./common/ChooseFile";
import { Form, InputGroup } from "react-bootstrap";

import emptyPreview from "../assets/images/EmptyPreview.svg";
import { FileDrop } from "react-file-drop";
import uploadImage from "../assets/images/upload.svg";
import CropImage from "./CropImage";
import LoadingView from "./common/LoadingView";
import ErrorView from "./common/ErrorView";
import { positions, useAlert } from "react-alert";
import { ChromePicker } from "react-color";
import NavBar from "./NavBar";
import NavBarNew from "./NavBarNew";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBodySummary,
  updateCoverPage,
  updateReportSummary,
  updateTestRecommendation,
  updateVizApp,
  updateSmartVideoReport,
  updatePrimaryColor,
  updateReportType,
  updateHeaderBase64,
  updateFooterBase64,
  updateLogoBase64,
  updateDoctorSignBase64,
  updateLogoFileName,
  updateLetterHeadFileName,
  updateDoctorSignFileName,
  updateUseDefaultLetterhead,
  updateIsHeaderCropped,
  updateIsFooterCropped,
} from "./features/reportConfig/reportConfigSlice";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Table } from "semantic-ui-react";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import walkthroughVideo from "../assets/images/Sample-generator-walkthrough.mp4";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ToolTip from "./common/ToolTip";
import { toolTipContent, letterhead } from "./utils";
import colorPicker from "../assets/images/colorPicker.gif";

const tooltipText = {
  logo: "Your logo will appear in our default cover page & as a part of default letterhead in the smart report",
  letterhead:
    "By adding letter head, the default header & footer will be over written.",
  primarycolor:
    "This will be taked as primary color in smart report (will be applied to letterhead & coverpage)",
  doctorsign: "This signature will be shown at the end of the smart report.",
};

const SampleReport = () => {
  const alert = useAlert();
  const {
    bodySummary,
    coverPage,
    reportSummary,
    testRecommendation,
    vizApp,
    smartVideoReport,
    primaryColor,
    reportType,
    headerBase64,
    footerBase64,
    logoBase64,
    doctorSignBase64,
    logoFileName,
    letterHeadFileName,
    doctorSignFileName,
    useDefaultLetterhead,
    isHeaderCropped,
    isFooterCropped,
  } = useSelector((state) => state.reportConfig);
  const dispatch = useDispatch();

  // const [reportType, setReportType] = useState("compact");
  const [addons, setAddons] = useState({
    bodySummary: false,
    coverPage: false,
    reportSummary: false,
    testRecommendation: false,
    vizApp: false,
    smartVideoReport: false,
  });
  const [open, setOpen] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [updatedJson, setUpdatedJson] = useState("");
  const [buttonId, setButtonId] = useState("");
  const [myFile, setMyFile] = useState({});
  const [headerMargin, setHeadermargin] = useState(130);
  const [footerMargin, setFooterMargin] = useState(100);
  // const [logoBase64, setLogoBase64] = useState("");
  const [letterHeadBase64, setLetterHeadBase64] = useState("");
  // const [doctorSignBase64, setDoctorSignBase64] = useState("");
  const [fileUploadError, setFileUploadError] = useState("");
  const [loader, setLoader] = useState(false);
  const [isHistorical, setIsHistorical] = useState(false);
  const [saveOption, setSaveOption] = useState(true);

  const [reportData, setReportData] = useState("");
  const [crop, setCrop] = useState({});
  const [cropLabel, setCropLabel] = useState("");
  const [headerFooterBase64, setHeaderFooterBase64] = useState({
    headerBase64: "",
    footerBase64: "",
  });
  const [showSignatureUpload, setShowSignatureUpload] = useState(false);
  const [centerName, setCenterName] = useState("demo_user");

  // const [primaryColor, setPrimaryColor] = useState("#2A7EC5");

  const fileInputRef = useRef(null);
  const mediaUploadInput = useRef(null);
  const canvasRef = useRef(null);

  // useEffect(() => {
  //   if (reportData) {
  //     setReportData("");
  //   }
  // }, [saveOption]);

  useEffect(() => {
    const loginData = localStorage.getItem("credentials");
    if (JSON.parse(loginData)) {
      setCenterName(JSON.parse(loginData)["center"]);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCropModalClose = () => {
    setCropModalOpen(false);
  };

  const smartReportConfig = {
    reportTypes: [
      { label: "Personal", value: "dynamic" },
      { label: "Total", value: "advanced" },
      { label: "Compact", value: "compact" },
    ],
    addons: [
      { label: "Body Summary", value: "bodySummary" },
      { label: "Cover Page", value: "coverPage" },
      { label: "Report Summary", value: "reportSummary" },
      { label: "Test Recommendation", value: "testRecommendation" },
    ],
    otherProducts: [
      {
        label: "Viz App",
        value: "vizApp",
        demolink: "https://www.demo-vizapp.niroggyan.com/overview",
      },
      {
        label: "Smart Video Report",
        value: "smartVideoReport",
        demolink:
          "https://niroggyan.s3.ap-south-1.amazonaws.com/demoSVRNiroggyan.mp4",
      },
    ],
    instructions: {
      logo: {
        fileType: "Only support png, svg and jpg files",
        size: "Maximum file size: Less than 500 KB",
      },
      letterHead: {
        fileType: "Only support png, svg and jpg files in A4 size",
        size: "Maximum file size: Less than 2 MB",
      },
      doctorSign: {
        fileType: "Only support png, svg and jpg files",
        size: "Maximum file size: Less than 500 KB",
      },
    },
  };

  const handleCheckBoxChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "bodySummary":
        dispatch(updateBodySummary(checked));
        break;
      case "coverPage":
        dispatch(updateCoverPage(checked));
        break;
      case "reportSummary":
        dispatch(updateReportSummary(checked));
        break;
      case "testRecommendation":
        dispatch(updateTestRecommendation(checked));
        break;
      case "vizApp":
        dispatch(updateVizApp(checked));
        break;
      case "smartVideoReport":
        dispatch(updateSmartVideoReport(checked));
        break;
      default:
    }
    // setAddons((prevState) => ({ ...prevState, [name]: checked }));
    setSaveOption(true);
  };

  const handleInputClick = (buttonType) => {
    // fileInputRef.current.click();
    setButtonId(buttonType);
    setOpen(true);
  };

  const convertBase64 = (file) => {
    if (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    } else {
      return "";
    }
  };

  const getSize = (bytes) => {
    if (bytes < 1024) {
      return `${bytes} Bytes`;
    } else if (bytes < 1024 * 1024) {
      const kb = bytes / 1024;
      return `${kb.toFixed(2)} KB`;
    } else {
      const mb = bytes / (1024 * 1024);
      return `${mb.toFixed(2)} MB`;
    }
  };

  const validateImageType = (fileName) => {
    console.log("fileName", fileName);
    let result =
      fileName.endsWith(".jpg") ||
      fileName.endsWith(".jpeg") ||
      fileName.endsWith(".png") ||
      fileName.endsWith(".svg");
    return !result;
  };

  const handleFileDrop = (files, event) => {
    if (files?.length > 1) {
      setFileUploadError("Please upload only 1 file.");
      setOpen(false);
      alert.error(
        <span className="alertError">Please upload only 1 file.</span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }
    if (
      !files[0]?.type.startsWith("image/") ||
      validateImageType(files[0]?.name)
    ) {
      setFileUploadError(
        "Only image files having JPG, JPEG, PNG, and SVG formats are allowed!"
      );
      setOpen(false);
      alert.error(
        <span className="alertError">
          Only image files having JPG, JPEG, PNG, and SVG formats are allowed!
        </span>,
        { position: positions.TOP_CENTER }
      );
      return;
    }

    if (files[0]) {
      let fileSizeInKb = files[0].size / 1024;
      let fileSizeInMb = files[0].size / (1024 * 1024);
      console.log("buttonId", buttonId);
      switch (buttonId) {
        case "logo":
          if (fileSizeInKb > 500) {
            setOpen(false);
            alert.error(
              <span className="alertError">
                The file size should be less than 500 KB
              </span>,
              { position: positions.TOP_CENTER }
            );
            return;
          }
          break;
        case "letterHead":
          if (fileSizeInMb > 2) {
            setOpen(false);
            alert.error(
              <span className="alertError">
                The file size should be less than 2 MB
              </span>,
              { position: positions.TOP_CENTER }
            );
            return;
          }
          break;
        case "doctorSign":
          if (fileSizeInKb > 500) {
            setOpen(false);
            alert.error(
              <span className="alertError">
                The file size should be less than 500 KB
              </span>,
              { position: positions.TOP_CENTER }
            );
            return;
          }
          break;
        default:
      }
    }

    if (files[0]) {
      console.log("sdasd", { [buttonId]: files[0] });
      setMyFile((prevState) => ({ ...prevState, [buttonId]: files[0] }));
    }
  };

  const handleSaveFile = async () => {
    setSaveOption(true);
    let base64 = await convertBase64(myFile[buttonId]);
    console.log("sadasd", base64);
    switch (buttonId) {
      case "logo":
        dispatch(updateLogoBase64(base64));
        dispatch(updateLogoFileName(myFile[buttonId].name));
        // setLogoBase64(base64);
        break;
      case "letterHead":
        setLetterHeadBase64(base64);
        dispatch(updateLetterHeadFileName(myFile[buttonId].name));
        break;
      case "doctorSign":
        dispatch(updateDoctorSignBase64(base64));
        dispatch(updateDoctorSignFileName(myFile[buttonId].name));
        // setDoctorSignBase64(base64);
        break;
      default:
    }

    setOpen(false);
    alert.success(<span>File Uploaded Succesfully!</span>, {
      position: positions.TOP_CENTER,
    });
  };

  console.log(
    "base64s",
    logoBase64,
    letterHeadBase64,
    doctorSignBase64,
    myFile
  );

  const handleUploadCancel = () => {
    setMyFile((prevState) => ({ ...prevState, [buttonId]: "" }));
    switch (buttonId) {
      case "logo":
        dispatch(updateLogoBase64(""));
        dispatch(updateLogoFileName(""));
        // setLogoBase64("");
        break;
      case "letterHead":
        setLetterHeadBase64("");
        dispatch(updateHeaderBase64(""));
        dispatch(updateFooterBase64(""));
        dispatch(updateLetterHeadFileName(""));
        dispatch(updateUseDefaultLetterhead(true));
        dispatch(updateIsHeaderCropped(false));
        dispatch(updateIsFooterCropped(false));
        generateDefaultHeaderFooter();
        break;
      case "doctorSign":
        dispatch(updateDoctorSignBase64(""));
        dispatch(updateDoctorSignFileName(""));
        // setDoctorSignBase64("");
        break;
      default:
    }
    setOpen(false);
    alert.info(<span>File Removed</span>, {
      position: positions.TOP_CENTER,
    });
    setSaveOption(true);
  };

  const mediaUploadDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          style: {
            height: "540px", // Set your desired height here
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ padding: "24px 24px 0px 24px" }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
            })}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h4">Media Upload</Typography>
          <Typography variant="body5" mt={1}>
            Add your supported files here
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              gap: 1,
            }}
          >
            <FileDrop
              onTargetClick={() => {
                mediaUploadInput.current.click();
                // setShowPreview(false);
              }}
              accept="image/*"
              // onFrameDragEnter={event => console.log('onFrameDragEnter', event)}
              // onFrameDragLeave={event => console.log('onFrameDragLeave', event)}
              // onFrameDrop={event => console.log('onFrameDrop', event)}
              // onDragOver={event => console.log('onDragOver', event)}
              // onDragLeave={event => console.log('onDragLeave', event)}
              onDrop={(files, event) => handleFileDrop(files, event)}
            >
              <Box
                sx={{
                  border: "1px solid #1849D6",
                  borderRadius: "8px",
                  background: "#E7ECFC",
                  width: "100%",
                  padding: "24px 0px",
                  height: Object.keys(myFile).length ? "100%" : "80%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <span>
                  <img src={uploadImage} alt="upload icon" />
                </span>

                <Typography variant="body6" mt={1.4}>
                  Drag your file to upload
                </Typography>

                <Typography variant="body7" my={1}>
                  OR
                </Typography>
                <Button
                  variant="outlined"
                  sx={{ fontSize: "12px", fontWeight: 600 }}
                >
                  Browse Files
                </Button>

                <input
                  style={{ visibility: "hidden", opacity: 0, height: "0px" }}
                  className="form-control"
                  id="fileupload"
                  type="file"
                  ref={mediaUploadInput}
                  multiple
                  accept="image/*"
                  onChange={(e) => {
                    handleFileDrop(e.target.files);
                  }}
                />
              </Box>
            </FileDrop>
            {/* file instructions */}
            {/* <Box>
              <Typography variant="body5" sx={{ textAlign: "center" }}>
                {`Only support png, svg and jpg files ${
                  buttonId === "letterHead" ? "in A4 size" : ""
                }`}
              </Typography>
              <Typography variant="body5" sx={{ textAlign: "center" }}>
                {`Maximum file size: Less than ${
                  buttonId === "letterHead" ? "2 MB" : "500 KB"
                }`}
              </Typography>
            </Box> */}

            {/* uploded file */}
            {Object.keys(myFile)?.length && myFile[buttonId] ? (
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                p={1}
                mb={2}
                sx={{
                  border: "1px solid #E7E7E7",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                <Stack gap={1} direction="row" flexGrow={1} alignItems="center">
                  <Box>
                    <InsertDriveFileTwoToneIcon sx={{ fontSize: 30 }} />
                  </Box>
                  <Box>
                    <Typography variant="body7">
                      {myFile[buttonId]?.name}
                    </Typography>
                    <Typography variant="body7" sx={{ textAlign: "left" }}>
                      {getSize(myFile[buttonId]?.size)}
                    </Typography>
                  </Box>
                </Stack>
                <Box>
                  <IconButton onClick={handleUploadCancel}>
                    <CancelTwoToneIcon />
                  </IconButton>
                </Box>
              </Stack>
            ) : (
              ""
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "0px 24px 24px" }}>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSaveFile} variant="outlined">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const imageCropDialog = () => {
    return (
      <Dialog
        open={cropModalOpen}
        onClose={handleCropModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        // PaperProps={{
        //   style: {
        //     height: "500px", // Set your desired height here
        //   },
        // }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ padding: "24px 24px 0px 24px" }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCropModalClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
            })}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h4">Crop Image</Typography>
          <Typography variant="body5" mt={2}>
            For the best results, please upload a letterhead image of A4 size at
            96 DPI. Ensure the header height is 150px and the footer height is
            120px for optimal placement.
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ marginTop: "16px" }}>
          <Box>
            <CropImage
              crop={crop}
              setCrop={setCrop}
              imgSrc={letterHeadBase64}
              cropLabel={cropLabel}
              setHeaderFooterBase64={setHeaderFooterBase64}
              handleCropModalClose={handleCropModalClose}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "0px 24px 24px" }}></DialogActions>
      </Dialog>
    );
  };

  const handleCanvasClick = (event) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const pixelData = ctx.getImageData(x, y, 1, 1).data; // Get RGBA of the clicked pixel
    const hexColor = `#${(
      (1 << 24) +
      (pixelData[0] << 16) +
      (pixelData[1] << 8) +
      pixelData[2]
    )
      .toString(16)
      .slice(1)}`;
    dispatch(updatePrimaryColor(hexColor));
    // setPrimaryColor(hexColor);
    setSaveOption(true);
  };

  const generateDefaultHeaderFooter = () => {
    if (headerBase64 && footerBase64 && !useDefaultLetterhead) {
      return;
    }
    let modifiedHeaderImg = letterhead.headerSVG.replace(
      /"{{customColor}}"/g,
      `"${primaryColor}"`
    );
    let modifiedFooterImg = letterhead.footerSVG.replace(
      /"{{customColor}}"/g,
      `"${primaryColor}"`
    );
    let defaultHeaderBase64 = btoa(modifiedHeaderImg);
    let defaultFooterBase64 = btoa(modifiedFooterImg);
    const base64HeaderUrl = `data:image/svg+xml;base64,${defaultHeaderBase64}`;
    const base64FooterUrl = `data:image/svg+xml;base64,${defaultFooterBase64}`;

    console.log("header", base64HeaderUrl);
    console.log("footer", base64FooterUrl);

    dispatch(updateHeaderBase64(base64HeaderUrl));
    dispatch(updateFooterBase64(base64FooterUrl));
    dispatch(updateUseDefaultLetterhead(true));
  };

  useEffect(() => {
    if (useDefaultLetterhead) {
      generateDefaultHeaderFooter();
    }
  }, [primaryColor]);

  const prepareFinalJson = () => {
    if (letterHeadBase64 && (!isHeaderCropped || !isFooterCropped)) {
      alert.error(
        <span className="alertError">
          Please crop your header & footer from the letterhead.
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      setUpdatedJson("");
      return;
    }
    // generateDefaultHeaderFooter();
    let finalJson = JSON.parse(JSON.stringify(SampleJsonData));
    if (isHistorical) {
      finalJson = JSON.parse(JSON.stringify(histroricalDummyData));
    }
    const reportConfiguration = {
      reportType: reportType,
      bodysummary: bodySummary,
      reportSummary: reportSummary,
      videoReport: smartVideoReport,
      vizapp: vizApp,
      coverPage: coverPage,
      testRecommendation: testRecommendation,
    };
    finalJson.reportConfiguration = reportConfiguration;
    finalJson.headerBase64 = headerBase64;
    finalJson.footerBase64 = footerBase64;
    finalJson.brandLogoBase64 = logoBase64;
    finalJson.primaryColor = primaryColor;
    finalJson.reportType = reportType;
    finalJson.isCustomClient = true;
    finalJson.defaultLetterHead = useDefaultLetterhead;
    // finalJson.ApprovedDoctorDetails[0].ApprovedDoctorSign = doctorSignBase64;
    finalJson.staticDocSignBase64 = doctorSignBase64;
    finalJson.org = centerName;
    finalJson.Centre = centerName;

    console.log("----final json ----", finalJson);
    setUpdatedJson(finalJson);
    setSaveOption(false);
    setReportData("");
  };

  const downloadReport = () => {
    const linkSource = reportData?.externalReportObjFileUrl
      ? reportData.externalReportObjFileUrl
      : `data:application/pdf;base64,${reportData.PdfData}`;
    const downloadLink = document.createElement("a");
    const fileName = `${reportData.LabId}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.target = "_blank";
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const generateReport = async () => {
    // if (letterHeadBase64 && (!headerBase64 || !footerBase64)) {
    //   alert.error(
    //     <span className="alertError">
    //       Please crop your header & footer from the letterhead.
    //     </span>,
    //     {
    //       position: positions.TOP_CENTER,
    //     }
    //   );
    //   return;
    // }
    setLoader(true);
    const apiUrl =
      "https://917sfoy1xc.execute-api.ap-south-1.amazonaws.com/production/pdfparserclients";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedJson),
    };

    try {
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      console.log("data", data);
      if (data?.PdfData || data?.externalReportObjFileUrl) {
        setReportData(data);
        alert.success(
          <span className="alertError">
            Successfully generated report. Please Click on "Download Report
            Button" to download your report.
          </span>,
          {
            position: positions.TOP_CENTER,
          }
        );
      } else {
        alert.error(
          <span className="alertError">
            Error generating pdf. Please try again
          </span>,
          {
            position: positions.TOP_CENTER,
          }
        );
      }
    } catch (e) {
      console.log("Generation Error", e);
      alert.error(
        <span className="alertError">
          Error generating pdf. Please try again
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    }
    setLoader(false);
    setUpdatedJson("");
    setSaveOption(true);
  };

  const generatedReportPreview = () => {
    return (
      <Stack gap={3} mt={4}>
        {/* <Box
          sx={{
            border: "1px solid rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            alignSelf: "stretch",
          }}
        >
          <Typography
            variant="body6"
            sx={{
              display: "block",
              background: "rgba(244, 247, 252, 0.75)",
              padding: "12px 20px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
              borderRadius: "8px 8px 0px 0px",
            }}
          >
            Your Sample Report
          </Typography>
          <img
            src="https://niroggyan.s3.ap-south-1.amazonaws.com/NirogyanCoverPage.png"
            width="100%"
            height="100px"
            alt="report"
            style={{
              objectFit: "cover",
              overflow: "hidden",
              objectPosition: "top",
              borderRadius: "0px 0px 8px 8px",
            }}
          />
        </Box> */}
        <Box sx={{ display: "none" }}>
          <Typography
            variant="body2"
            sx={{ color: "rgba(74, 74, 74, 1)" }}
            mb={1}
          >
            Your smart report is ready!
          </Typography>

          {/* download report */}
          <Button
            variant="outlined"
            // sx={{ width: "60%" }}
            onClick={downloadReport}
          >
            Download Report{" "}
            <span className="ms-1">
              <FileDownloadOutlinedIcon />
            </span>
          </Button>
        </Box>

        {/* viz app detail */}
        <Box sx={{ width: { md: "50%", sm: "100%", xs: "100%" } }}>
          {reportData?.vizAppUrl ? (
            <Table striped>
              <>
                <thead>
                  <tr className="text-center">
                    <th style={{ fontWeight: "600", width: "25%" }}>
                      Viz App Link
                    </th>
                    <th style={{ fontWeight: "600", width: "25%" }}>
                      Viz App Password
                    </th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  <tr>
                    {reportData?.vizAppUrl ? (
                      <td>
                        <a href={reportData.vizAppUrl} target="_blank">
                          Open Viz App
                        </a>
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                    {reportData?.vizAppPassword ? (
                      <td>
                        <p>{reportData.vizAppPassword}</p>
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                  </tr>
                </tbody>
              </>
            </Table>
          ) : (
            ""
          )}
        </Box>
      </Stack>
    );
  };

  const handleSignToggle = () => {
    setShowSignatureUpload((prev) => !prev);
  };

  const FileInstructions = ({ text, position = "" }) => {
    return (
      <Typography
        sx={{
          fontSize: "12px",
          float: position ? "right" : "",
          margin: position ? "4px 4px 0px 0px" : "",
        }}
      >
        {text}
      </Typography>
    );
  };

  console.log("reportData", reportData);

  return (
    <>
      <NavBarNew />
      <Box sx={{ padding: "0px 6%" }} mt={3}>
        <Typography variant="h1">Sample Report Generation</Typography>

        <Box sx={{ padding: "20px 0px" }}>
          <Stack
            justifyContent={"space-between"}
            gap={5}
            sx={{
              flexDirection: {
                lg: "row",
                md: "row",
                sm: "column",
                xs: "column",
              },
            }}
          >
            <Box flexGrow={1} sx={{ minWidth: "55%" }}>
              <Box
                sx={{ width: { lg: "90%", md: "80%", sm: "100%", xs: "100%" } }}
              >
                {/* file & log upload */}
                <Stack gap={2}>
                  <Box>
                    <Stack
                      direction="row"
                      alignItems="center"
                      gap={1}
                      flexWrap={"wrap"}
                    >
                      <Typography variant="body2">
                        Add your logo <ToolTip title={tooltipText.logo} />
                      </Typography>
                      <FileInstructions
                        text={smartReportConfig.instructions.logo.fileType}
                      />
                    </Stack>

                    <Stack
                      direction={"row"}
                      alignItems="center"
                      mt={1.2}
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleInputClick("logo")}
                    >
                      <ChooseFile />
                      <TextField
                        label=""
                        fullWidth
                        placeholder="No file chosen"
                        // value={
                        //   myFile?.["logo"]?.name && logoBase64
                        //     ? myFile["logo"].name
                        //     : ""
                        // }
                        value={logoFileName || ""}
                        size="small"
                        sx={{
                          cursor: "pointer",
                          "&:hover": { cursor: "pointer" },
                          "&:focus": { cursor: "pointer" },
                        }}
                        InputProps={{
                          readOnly: true, // Make it read-only so user can't type manually
                        }}
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const fileName =
                            e.target.files[0]?.name || "No file chosen";
                          // Update the TextField or state with the file name
                        }}
                      />
                    </Stack>
                    <FileInstructions
                      text={smartReportConfig.instructions.logo.size}
                      position="bottom"
                    />
                  </Box>
                  {/* color picker */}
                  <Stack>
                    {logoBase64 && (
                      <Box>
                        <canvas
                          ref={canvasRef}
                          onClick={handleCanvasClick}
                          width="500"
                          height="100"
                          style={{
                            border: "1px solid black",
                          }}
                        />
                        <img
                          src={logoBase64}
                          alt="Uploaded"
                          style={{ display: "none" }}
                          onLoad={(e) => {
                            const canvas = canvasRef.current;
                            const ctx = canvas.getContext("2d");
                            const img = e.target;
                            ctx.drawImage(
                              img,
                              0,
                              0,
                              canvas.width,
                              canvas.height
                            ); // Draw image on the canvas
                          }}
                        />
                      </Box>
                    )}
                    <Box mt={2}>
                      <Tooltip
                        title={tooltipText.primarycolor}
                        sx={{ textTransform: "none" }}
                      >
                        <InputGroup
                          className="mb-3 mx-1"
                          style={{ width: "100%", textTransform: "capitalize" }}
                        >
                          <InputGroup.Text>
                            <b>Primary Color</b>
                          </InputGroup.Text>
                          <InputGroup.Text>{primaryColor}</InputGroup.Text>
                          <input
                            value={primaryColor}
                            onChange={(event) => {
                              dispatch(updatePrimaryColor(event.target.value));
                              // setPrimaryColor(event.target.value);
                              setSaveOption(true);
                            }}
                            type="color"
                            className="form-control form-control-color"
                            placeholder="Select Color"
                          />
                        </InputGroup>
                      </Tooltip>
                    </Box>
                    {/* demo GIF */}
                    {logoBase64 ? (
                      <img
                        src={colorPicker}
                        alt="picker GIF"
                        height="150px"
                        style={{ objectFit: "contain" }}
                      />
                    ) : (
                      ""
                    )}
                  </Stack>

                  <Box>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      gap={1}
                      flexWrap={"wrap"}
                    >
                      <Typography variant="body2">
                        Add your letterhead{" "}
                        <ToolTip title={tooltipText.letterhead} />
                      </Typography>
                      <FileInstructions
                        text={
                          smartReportConfig.instructions.letterHead.fileType
                        }
                      />
                    </Stack>

                    <Stack
                      direction={"row"}
                      alignItems="center"
                      mt={1.2}
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleInputClick("letterHead")}
                    >
                      <ChooseFile />
                      <TextField
                        label=""
                        fullWidth
                        placeholder="No file chosen"
                        size="small"
                        // value={
                        //   myFile?.["letterHead"]?.name && letterHeadBase64
                        //     ? myFile["letterHead"].name
                        //     : ""
                        // }
                        value={letterHeadBase64 ? letterHeadFileName : ""}
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const fileName =
                            e.target.files[0]?.name || "No file chosen";
                          // Update the TextField or state with the file name
                        }}
                      />
                    </Stack>
                    <FileInstructions
                      text={smartReportConfig.instructions.letterHead.size}
                      position="bottom"
                    />

                    {/* header & footer margins */}
                    {/* <Stack direction="row" alignItems="center" gap={3} mt={2}>
                  <TextField
                    required
                    label="Header margin in px"
                    type="number"
                    value={headerMargin}
                    onChange={(e) => setHeadermargin(e.target.value)}
                    fullWidth
                    placeholder="No file chosen"
                    size="small"
                  />
                  <TextField
                    required
                    label="Footer margin in px"
                    type="number"
                    fullWidth
                    placeholder="No file chosen"
                    size="small"
                    value={footerMargin}
                    onChange={(e) => setFooterMargin(e.target.value)}
                  />
                </Stack> */}

                    {/* crop buttons */}
                    <Stack direction="row" gap={2} mt={2}>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setCropLabel("header");
                          setCropModalOpen(true);
                        }}
                        disabled={!myFile["letterHead"]}
                      >
                        Crop header*
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={() => {
                          setCropLabel("footer");
                          setCropModalOpen(true);
                        }}
                        disabled={!myFile["letterHead"]}
                      >
                        Crop footer*
                      </Button>
                      {imageCropDialog()}
                    </Stack>
                    <Box mt={1}>
                      <FileInstructions
                        text="Please crop your header & footer once you upload the letter
                      head"
                      />
                    </Box>
                  </Box>
                  {/* doctor signature */}
                  <Box>
                    <Typography
                      mb={1}
                      sx={{ fontSize: "20px", color: "#000000" }}
                    >
                      Want to add doctor signature ?{" "}
                      <IconButton onClick={handleSignToggle}>
                        {!showSignatureUpload ? (
                          <AddCircleIcon />
                        ) : (
                          <RemoveCircleIcon />
                        )}
                      </IconButton>
                    </Typography>
                    {showSignatureUpload ? (
                      <Box>
                        <Stack direction="row" alignItems="center" gap={1}>
                          <Typography
                            variant="body2"
                            sx={{ cursor: "pointer" }}
                          >
                            Add Doctor Signature{" "}
                            <ToolTip title={tooltipText.doctorsign} />
                          </Typography>
                          <FileInstructions
                            text={
                              smartReportConfig.instructions.doctorSign.fileType
                            }
                          />
                        </Stack>

                        <Stack
                          direction={"row"}
                          alignItems="center"
                          mt={1.2}
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleInputClick("doctorSign")}
                        >
                          <ChooseFile />
                          <TextField
                            label=""
                            fullWidth
                            placeholder="No file chosen"
                            size="small"
                            // value={
                            //   myFile?.["doctorSign"]?.name && doctorSignBase64
                            //     ? myFile["doctorSign"].name
                            //     : ""
                            // }
                            value={doctorSignFileName || ""}
                          />
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const fileName =
                                e.target.files[0]?.name || "No file chosen";
                              // Update the TextField or state with the file name
                            }}
                          />
                        </Stack>
                        <FileInstructions
                          text={smartReportConfig.instructions.doctorSign.size}
                          position="bottom"
                        />
                      </Box>
                    ) : (
                      ""
                    )}
                  </Box>

                  {/* dialog */}
                  {mediaUploadDialog()}
                </Stack>
              </Box>
            </Box>
            {/* viz app section */}

            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              component="div"
              sx={{
                borderWidth: "2px",
                marginLeft: "-20px",
                display: { md: "block", sm: "none", xs: "none" },
              }}
            />

            <Box flexGrow={2} alignSelf={"center"}>
              <Box sx={{ width: "100%" }}>
                {/* report type & add-ons */}
                <Stack gap={3}>
                  {/* select report type */}
                  <Box>
                    <Typography variant="body2">Select Report Type</Typography>
                    <Box>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          defaultValue={reportType}
                          onChange={(e) => {
                            dispatch(updateReportType(e.target.value));
                            // setReportType(e.target.value);
                            setSaveOption(true);
                          }}
                        >
                          {smartReportConfig.reportTypes.map((each, idx) => (
                            <FormControlLabel
                              key={idx}
                              value={each.value}
                              control={<Radio />}
                              label={
                                <Typography variant="body4">
                                  {each.label}&nbsp;&nbsp;&nbsp;
                                  <ToolTip title={toolTipContent[each.label]} />
                                </Typography>
                              }
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </Box>
                    {/* historical toggle */}
                    <Stack direction="row" gap={2} alignItems="center">
                      <FormControlLabel
                        value={isHistorical}
                        disabled={reportType === "compact"}
                        control={<Switch color="primary" />}
                        label={
                          <Typography variant="body4">
                            Historical&nbsp;&nbsp;&nbsp;
                            <ToolTip title={toolTipContent["historical"]} />
                          </Typography>
                        }
                        labelPlacement="start"
                        onChange={(e) => {
                          setIsHistorical(e.target.checked);
                          setSaveOption(true);
                        }}
                        sx={{
                          margin: 0,
                          flexDirection: "row",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "16px",
                            color: "#000000",
                          },
                        }}
                      />
                      {reportType === "compact" && (
                        <Typography variant="body5">
                          Currently we dont provide historical option for
                          compact reports
                        </Typography>
                      )}
                    </Stack>
                  </Box>

                  {/* select add-ons */}
                  <Box>
                    <Typography variant="body2">Select Add-ons</Typography>
                    <Box>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          {smartReportConfig.addons.map((each, idx) => (
                            <FormControlLabel
                              key={idx}
                              name={each.value}
                              control={<Checkbox />}
                              onChange={handleCheckBoxChange}
                              label={
                                <Typography variant="body4">
                                  {each.label}&nbsp;&nbsp;&nbsp;
                                  <ToolTip title={toolTipContent[each.label]} />
                                </Typography>
                              }
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>

                  {/* enhance products section */}
                  <Box>
                    <Typography variant="body2">
                      Enhance your products
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                      A sample data is considered for demo purposes only.
                      Available exclusively for files generated via CSV upload
                      or manual entry.
                    </Typography>
                    <Box mt={1.5}>
                      <FormControl sx={{}}>
                        <RadioGroup
                          sx={{ gap: 1 }}
                          column
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          {smartReportConfig.otherProducts.map((each, idx) => (
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={1}
                            >
                              <FormControlLabel
                                key={idx}
                                sx={{
                                  backgroundImage:
                                    "radial-gradient(circle, rgba(136, 231, 253, 1), rgba(255, 255, 255, 1))",
                                  boxShadow:
                                    "0px 2px 4px 1px rgba(0, 0, 0, 0.06)",
                                  border: "1px solid #E8E8E8",
                                  borderRadius: "8px",
                                  margin: "0px",
                                  width: "200px",
                                }}
                                name={each.value}
                                control={<Checkbox />}
                                onChange={handleCheckBoxChange}
                                label={
                                  <Typography
                                    variant="body5"
                                    sx={{ color: "#444750" }}
                                  >
                                    {each.label}
                                  </Typography>
                                }
                              />
                              <a href={each.demolink} target="_blank">
                                <Typography
                                  variant="body5"
                                  sx={{
                                    color: "#444750",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    "&:hover": { color: "blue" },
                                  }}
                                >
                                  Demo link
                                </Typography>
                              </a>
                            </Stack>
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>
                </Stack>

                {/* {!reportData ? (
                  <Stack alignItems={"center"} mt={1.4}>
                    <img
                      src={emptyPreview}
                      alt="smart report preview"
                      width="50%"
                    />
                    <Typography variant="body3">
                      Your smart report will appear here!
                    </Typography>
                  </Stack>
                ) : (
                  generatedReportPreview()
                )} */}
              </Box>
            </Box>
          </Stack>
          {/* buttons */}
          <Box mt={1.5}>
            <Tooltip
              arrow
              placement="right"
              title={!saveOption ? "No changes to save" : ""}
            >
              <span>
                <Button
                  variant="outlined"
                  disabled={!saveOption}
                  onClick={prepareFinalJson}
                >
                  Save Configurations
                </Button>
              </span>
            </Tooltip>
          </Box>
          <Box mt={2}>
            {/* manual & upload options */}
            <Box>
              <Typography sx={{ color: "#000000" }}>
                How do you want to generate the report?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} gap={1.5} my={2}>
                <Typography variant="body8">
                  Generate report from the sample data
                </Typography>
                <Tooltip
                  arrow
                  placement="top"
                  title={
                    !updatedJson
                      ? "Please save configurations to generate report."
                      : ""
                  }
                >
                  <span style={{ cursor: "pointer" }}>
                    <Button
                      variant="outlined"
                      disabled={!updatedJson}
                      onClick={generateReport}
                      sx={{ width: "228px" }}
                    >
                      Generate Sample Report
                    </Button>
                  </span>
                </Tooltip>

                {reportData ? (
                  <Button
                    variant="outlined"
                    // sx={{ width: "60%" }}
                    onClick={downloadReport}
                    sx={{
                      borderRadius: "20px",
                      border: "none",
                      background: "#009b3f",
                      outline: "2px solid #fff",
                      boxShadow: "2px 4px 6px rgba(0,0,0,0.3)",
                      color: "#fff",

                      "&:hover": {
                        outline: "none",
                        background: "#009b3f",
                        border: "none",
                      },
                    }}
                  >
                    Download Report{" "}
                    <span className="ms-1">
                      <FileDownloadOutlinedIcon />
                    </span>
                  </Button>
                ) : (
                  ""
                )}
              </Stack>

              <Stack direction={"row"} alignItems={"center"} gap={1.5} my={2}>
                <Typography variant="body8">Upload CSV</Typography>

                <Link to={updatedJson ? "/upload-file" : "#"}>
                  <Tooltip
                    title={
                      !updatedJson
                        ? "Please click on save configurations before proceeding"
                        : ""
                    }
                    arrow
                    placement="right"
                  >
                    <span>
                      <Button
                        variant="outlined"
                        disabled={!updatedJson}
                        sx={{ fontSize: "12px", padding: "6px 10px" }}
                      >
                        Upload CSV
                        <span className="ms-1">
                          <NorthEastIcon sx={{ fontSize: "16px" }} />
                        </span>
                      </Button>
                    </span>
                  </Tooltip>
                </Link>
              </Stack>
              <Stack direction={"row"} alignItems={"center"} gap={1.5}>
                <Typography variant="body8">Enter data manually</Typography>
                <Link to={updatedJson ? "/Manual-Entry-Home-Page" : ""}>
                  <Tooltip
                    arrow
                    placement="right"
                    title={
                      !updatedJson
                        ? "Please click on save configurations before proceeding"
                        : ""
                    }
                  >
                    <span>
                      <Button
                        disabled={!updatedJson}
                        variant="outlined"
                        sx={{ fontSize: "12px", padding: "6px 10px" }}
                      >
                        Manual Entry
                        <span className="ms-1">
                          <NorthEastIcon sx={{ fontSize: "16px" }} />
                        </span>
                      </Button>
                    </span>
                  </Tooltip>
                </Link>
              </Stack>
            </Box>
            {/* <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems={"center"}
                gap={1.5}
                sx={{
                  border: "1px solid #1849D6",
                  padding: "12px 20px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={uploadImage}
                  alt="upload-logo"
                  width="24px"
                  height="24px"
                />
                <Box>
                  <Typography variant="body6" sx={{ fontWeight: 600 }}>
                    Upload CSV file
                  </Typography>
                  <Typography variant="body7">
                    Choose your file to upload
                  </Typography>
                </Box>
                <Link to="/upload-file">
                  <Button
                    variant="outlined"
                    sx={{ fontSize: "12px", padding: "6px 10px" }}
                  >
                    Upload CSV
                    <span className="ms-1">
                      <NorthEastIcon sx={{ fontSize: "16px" }} />
                    </span>
                  </Button>
                </Link>
              </Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems={"center"}
                gap={1.5}
                sx={{
                  border: "1px solid #1849D6",
                  padding: "12px 20px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={uploadImage}
                  alt="upload-logo"
                  width="24px"
                  height="24px"
                />
                <Box>
                  <Typography variant="body6" sx={{ fontWeight: 600 }}>
                    Manual Entry
                  </Typography>
                  <Typography variant="body7">
                    Generate report manually
                  </Typography>
                </Box>
                <Link to="/Manual-Entry-Home-Page">
                  <Button
                    variant="outlined"
                    sx={{ fontSize: "12px", padding: "6px 10px" }}
                  >
                    Manual Entry
                    <span className="ms-1">
                      <NorthEastIcon sx={{ fontSize: "16px" }} />
                    </span>
                  </Button>
                </Link>
              </Stack>
            </Stack> */}
            <Box mt={2} sx={{ display: "flex", gap: 2 }}>
              {/* <Button
                variant="outlined"
                disabled={!saveOption}
                onClick={prepareFinalJson}
              >
                Save Changes
              </Button>
              <Button
                variant="outlined"
                disabled={!updatedJson}
                onClick={generateReport}
                sx={{ width: "228px" }}
              >
                {loader ? (
                  <CircularProgress size="20px" />
                ) : (
                  "Generate Sample Report"
                )}
              </Button> */}

              {/* <Link to="/upload-file">
                <Button variant="outlined">Upload file</Button>
              </Link>
              <Link to="/Manual-Entry-Home-Page">
                <Button variant="outlined">Manual Entry</Button>
              </Link> */}
            </Box>
            {reportData ? <Box>{generatedReportPreview()}</Box> : ""}
          </Box>

          {/* loader */}
          {loader ? (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                position: "fixed",
                top: "0",
                left: "0",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <CircularProgress sx={{ color: "#fff" }} />
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default SampleReport;
